var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tr',[_c('th',{class:{ form_line_l: _vm.hasClosingLine }}),_c('td',{class:{ form_line_r: _vm.hasClosingLine }},[_c('p',[_vm._v(_vm._s(_vm.$t('contactGuidance.text')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }